import React from 'react';
import {
  EntityDependsOnResourcesCard,
  EntityLayout,
} from '@backstage/plugin-catalog';
import { RTLLinksCard } from '../../cards/LinksCard';
import { Grid } from '@material-ui/core';
import { WarningCard } from '../../cards/WarningCard';
import { Direction } from '@backstage/plugin-catalog-graph';
import { RTLCatalogGraphCard } from '../../cards/CatalogGraphCard';
import {
  RELATION_DEPENDENCY_OF,
  RELATION_DEPENDS_ON,
  RELATION_PART_OF,
} from '@backstage/catalog-model';
import { RTLAboutCard } from '../../cards/AboutCard';
import { HasFilteredResourcesCard } from '../../cards/HasFilteredResourcesCard';
import { hasClusterSlices } from '../../cards/utils';
import {
  RELATION_DEPLOYED_IN,
  RELATION_HOSTS,
} from '@internal/backstage-plugin-catalog-backend-module-rtl/src/processors/realtions';

export const ResourcePage = () => (
  <EntityLayout>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={3} alignItems="stretch">
        <WarningCard />
        <Grid item md={6} sm={12}>
          <RTLAboutCard />
        </Grid>
        <Grid item md={6} sm={12}>
          <RTLCatalogGraphCard
            height={400}
            relations={[
              RELATION_DEPENDS_ON,
              RELATION_DEPENDENCY_OF,
              RELATION_DEPLOYED_IN,
              RELATION_HOSTS,
            ]}
          />
        </Grid>
        <RTLLinksCard />
        <Grid item xs={12}>
          <EntityDependsOnResourcesCard />
        </Grid>
      </Grid>
    </EntityLayout.Route>
    {/*
      Only a Kubernetes cluster is cut into slices, and the page is shared by
      every kind of resource, so the tab is tied to the type - and to there
      being a slice, a cluster is not always cut up.
    */}
    <EntityLayout.Route
      path="/kubernetes"
      title="Kubernetes"
      if={e => e.spec?.type === 'k8s-cluster' && hasClusterSlices(e)}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {/*
            The slices of a cluster mostly belong to other products, which is
            what the product column of the table is there for.
          */}
          <HasFilteredResourcesCard
            type="k8s-cluster-slice"
            title="Kubernetes Cluster Slices"
          />
        </Grid>
      </Grid>
    </EntityLayout.Route>
    <EntityLayout.Route path="/diagram" title="Diagram">
      <RTLCatalogGraphCard
        direction={Direction.TOP_BOTTOM}
        title="Resource Diagram"
        height={700}
        relations={[
          RELATION_PART_OF,
          RELATION_DEPENDENCY_OF,
          RELATION_DEPENDS_ON,
        ]}
        unidirectional={false}
      />
    </EntityLayout.Route>
  </EntityLayout>
);
